export default __webpack_public_path__ + "static/media/JovanaLovelace.8840920e.png";